export default __webpack_public_path__ + "static/media/menu-vip-logo-default.117df042.webp";